import { makeStore } from '../customStore';
export const ADMIN_MODE = makeStore(false);
export const LORCA_OVERRIDE = makeStore(false);
export const devToolsEnabled = makeStore(false);
export const lastSaved = makeStore(Date.now());
export const totalTimePlayed = makeStore(0);
export const currentThoughtBoost = makeStore(1);
export const currentThoughtBoostTime = makeStore(0);
export const currentCheeseQueue = makeStore(0);
export const cheeseQueueActive = makeStore(false);
export const cheeseQueueOverclockLvl = makeStore(0);
export const cheeseQueueTotalCycles = makeStore(0);
export const cheeseFactoryMode = makeStore('nominal');
export const totalCheeseMonsterDeaths = makeStore(0);
export const brainMode = makeStore('peaceful');
export const highestMilk = makeStore(0);
